import { IModuleApi, Lesson } from 'src/service/api/api.types'

export interface reduceProgressType {
  progress: number
  lessons: number
}

export const calcProgressCourse = (modules: IModuleApi[] | undefined) => {
  const reduceInit = {
    progress: 0,
    lessons: 0,
  }

  if (!modules) {
    return reduceInit
  }

  return modules.reduce((progressCourse, course) => {
    const was = course.lessons.filter(item => item.wasWatched)
    if (was && was.length > 0) {
      progressCourse.progress += was.length
    }
    progressCourse.lessons += course.lessons.length
    return progressCourse
  }, reduceInit)
}

export const calcProgressModule = (lessons: Lesson[]) => {
  const reduceInit: reduceProgressType = {
    progress: 0,
    lessons: 0,
  }

  if (!lessons) {
    return reduceInit
  }

  return lessons.reduce((progressCourse, lesson, currentIndex, array) => {
    if (lesson.wasWatched) {
      progressCourse.progress += 1
    }
    progressCourse.lessons = array.length
    return progressCourse
  }, reduceInit)
}
